import BaseCustomSelect from './baseComponents/BaseCustomSelect';
import countries from './data/countries';
import getCookie from './utils/getCookie';

/**
 * A custom element for enhancing a <select> tag of countries into a custom combobox with icons for each selection
 *
 * @module iabbb-ls-country-custom-select
 */
class LocaleSelectorCountryCustomSelect extends BaseCustomSelect {
  getInitialValue = () => {
    const savedCulture = getCookie('iabbb_user_culture');

    if (!savedCulture) {
      return this.select.value;
    }

    return countries.find((x) => x.culture === savedCulture)?.value || this.select.value;
  };

  getOptionHtml = (val) => {
    const country = countries.find((x) => x.value === val);
    return `<img src="${country.flag}" alt="" /><span class="option-label">${country.fullLabel}</span>`;
  };

  optionClassName = 'dtm-locale-selector-country';
}

customElements.define('iabbb-ls-country-custom-select', LocaleSelectorCountryCustomSelect);
